
import { defineComponent, PropType } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import { formatDateFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
    components: { Cheap },
    setup() {
        return {
            formatDateFromBackend
        }
    }
})
